module.exports = "#navbar ul li a{padding:25px 10px !important; color:#fff; cursor:pointer;}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/header/header.component.css
// module id = ./src/app/layout/header/header.component.css
// module chunks = main